var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"reg",attrs:{"id":"registration"}},[_c('div',{staticClass:"card-alt mt-0"},[_c('div',{staticClass:"card-alt-body"},[_c('router-view')],1)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-656db2f6","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/registration.vue
// module id = 3NHr
// module chunks = 1